import { action, observable } from 'mobx';
import { BaseViewStore, BaasicDropdownStore } from 'core/stores';
import { PumpStatusChangeForm } from 'application/pumps/forms';
import { FacilityPumpService, } from 'application/pumps/services';
import _ from 'lodash';

class PumpStatusChangeViewStore extends BaseViewStore {
    form = new PumpStatusChangeForm({
        onSuccess: async form => {
            await this.onSubmit(form.values());
        }
    });

    @observable accessor selectedStatus = null;
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.item = this.modalParams.data.item;
        this.form.update(this.item);
        let status = this.modalParams.data.item.status
        this.displayStatusDate(status);
        this.selectedStatus = status;

        this.service = new FacilityPumpService(rootStore.application.baasic.apiClient);

        this.statusStore = new BaasicDropdownStore({
        }, {
            fetchFunc: async() => {
                const response = await this.service.getStatus();
                return response;
            },
            onChange: (item) => {
                let selectedItem = _.find(this.statusStore.originalItems, {id: item});
                this.displayStatusDate(selectedItem);
                this.selectedStatus = selectedItem;
            }
        });
    }

    @action.bound
    displayStatusDate(status) {
        if(status.abrv === 'return-requested'){
            this.form.fields.get('dateReturnRequested').set('rules', 'required');
            this.form.set({dateSent: this.item.dateSent, dateReturned: this.item.dateReturned});
            if(!this.item.dateReturnRequested)	
               this.form.set({dateReturnRequested: new Date()});
            this.form.fields.get('dateReturned').set('rules', null);	
            this.form.fields.get('dateSent').set('rules', null);	
        }else if(status.abrv === 'returned'){
            this.form.fields.get('dateReturned').set('rules', 'required');	
            this.form.set({dateSent: this.item.dateSent, dateReturnRequested: this.item.dateReturnRequested});
            if(!this.item.dateReturned)	
                this.form.set({dateReturned: new Date()});
            this.form.fields.get('dateReturnRequested').set('rules', null);	
            this.form.fields.get('dateSent').set('rules', null);	
        }else{
            this.form.fields.get('dateSent').set('rules', 'required');	
            this.form.set({dateReturnRequested: this.item.dateReturnRequested, dateReturned: this.item.dateReturned});
            if(!this.item.dateSent)	
                this.form.set({dateSent: new Date()});
            this.form.fields.get('dateReturned').set('rules', null);	
            this.form.fields.get('dateReturnRequested').set('rules', null);	
        }
    }

    @action.bound
    async onSubmit(data) {
        data.id = this.modalParams.data.item.id;
        this.form.setFieldsDisabled(true);
        try {

            await this.service.updateStatus(data);

            this.modalParams.close();
            this.rootStore.notificationStore.success('Pump Status successfully updated.');
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error('Error occured while trying to update Pump Status.');
        }
    }
}

export default PumpStatusChangeViewStore;
